export default __webpack_public_path__ + "static/media/litho-demo-maintenance.d14873df.jpg";